import request from '@/utils/request'

const _Prefix = '/system/learningManagerInfo'

// 查询学习信息列表
export function learningList (query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}

// 查询学习信息详细
export function getLearning (id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增学习信息
export function addLearning (data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改学习信息
export function updateLearning (data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除学习信息
export function delLearning (ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}
